export enum Namespaces {
    login = "login",
    register = "register",
    password = "password",
    accountEdit = "accountEdit",
    accountMobile = "accountMobile",
    userAgreement = "userAgreement",
}

/**
 * 性别
 */
export enum authGenderEnum {
    /**
     * 男
     */
    male = 1,

    /**
     * 女
     */
    female = 2,

    /**
     * 女
     */
    unknown = 3,
}

/**
 * 注册信息表单布局
 */
export const FORM_ITEM_LAYOUT = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
/**
 * 用户协议表单布局
 */
export const TAIL_FORM_ITEM_LAYOUT = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};
